<template>
  <div>
    <h1>Resultado del envío</h1>
    <div class="my-3">
      <b-card bg-variant="light">
        <b-card-text class="text-center">
          <div v-if="seccionactiva == 'ESPECIALES-CONTRATOSNAC'">
            <p>
              El contrato <strong>{{ datosdocumento.descripcion }}</strong> ha sido enviado con éxito.
            </p>
          </div>
          <div v-else>
            <p>
              El documento <strong>{{ datosdocumento.descripcion }}</strong> ha sido enviado con éxito.
            </p>
          </div>
          <p class="text-center">
            Descárgate el documento enviado a través de este enlace<br />
            <b-button v-b-modal.modal-1 @click="descargarDocumento()" class="btn btn-manusa">{{ resultadoefirma.datosenviados.fichero }}</b-button>
          </p>
          <p>
            Signaturit identifica el documento con el siguiente código
            <strong>{{ resultadoefirma.datosrecibidos.id }}</strong>
          </p>
          <div class="py-2">
            El documento se ha enviado a firmar a las siguientes personas
            <b-list-group>
              <b-list-group-item v-for="(f, index) in resultadoefirma.datosrecibidos.documents" :key="'f' + index"> {{ f.name }} &lt;{{ f.email }}&gt; </b-list-group-item>
            </b-list-group>
          </div>
          <p>
            Recuerda que podrás hacer un seguimiento de éste y otros documentos enviados a firmar accediendo a
            <a href="/gestion-documentos-listado">Mis eFirmas</a>.
          </p>
        </b-card-text>
      </b-card>
    </div>
    <b-modal size="xl" id="modal-1" :title="titulopdf">
      <AbrirPDF v-if="titulopdf.length" :src="srcpdf"></AbrirPDF>
    </b-modal>
  </div>
</template>

<script>
import AbrirPDF from '@/components/AbrirPDF.vue';
export default {
  components: {
    AbrirPDF
  },
  props: {
    seccionactiva: {
      type: String,
      default: ''
    },
    datosdocumento: {
      type: Object,
      default: null
    },
    resultadoefirma: Object
  },
  data() {
    return {
      titulopdf: '',
      srcpdf: ''
    };
  },
  mounted() {
    // const baseURL = process.env.VUE_APP_HOSTPYAPI;
    // // process.env.NODE_ENV !== "production"
    // //   ? process.env.VUE_APP_API_MANUSA_DEV
    // //   : process.env.VUE_APP_API_MANUSA_PROD;
    // // alert('[TODO] ATENCION AQUI... URL REQUIERE TRATAMIENTO ESPECIAL PARA PYAPI!!!!');
    // // this.enlacepdforiginal = baseURL + '/efirma/descargar-documento-original/' + this.resultadoefirma.datosrecibidos.id;
    // this.enlaceMisEFirmas = '/gestion-documentos-listado';
  },
  methods: {
    //'original', row.item.id, row.item.docs[0].id
    descargarDocumento() {
      if (this.resultadoefirma) {
        let url = 'get-base64-documento-original/' + this.$store.getters.miModoApp + '/' + this.resultadoefirma.datosrecibidos.id + '/' + this.resultadoefirma.datosrecibidos.documents[0].id;
        console.log(url);
        var _t = this;
        _t.titulopdf = '';
        _t.srcpdf = '';
        //this.axios.defaults.baseURL = process.env.VUE_APP_API_URL
        this.axios
          .post(
            '/efirma/accion',
            { accion: url, method: 'GET', resptype: 'text' },
            {
              headers: {
                Authorization: `Bearer xuhnrfrQOGsJZAGwSFwpNAAOvYUHnmEixEHMVYADxVjMfOZTsATgqeqDJTsSbJJULMbwESdEyOWQhNnOZLoasL`
              }
            }
          )
          .then(function (response) {
            _t.titulopdf = 'Documento - original';
            _t.srcpdf = 'data:application/pdf;base64,' + response.data;
            console.log('Respuesta API', _t.srcpdf.length);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
};
</script>
